import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type Props = {
  children: ReactNode
  className?: string
  fluid?: boolean
  /** Vertical stack with consistent page gap (default true). */
  stack?: boolean
}

export function PageContainer({ children, className, fluid, stack = true }: Props) {
  return (
    <div
      className={cn(
        'w-full min-w-0',
        fluid
          ? 'px-3 py-4 sm:px-4 sm:py-5 lg:px-5'
          : 'mx-auto max-w-[1600px] px-4 py-5 sm:px-6 sm:py-6 lg:px-8',
        stack && 'page-stack',
        className
      )}
    >
      {children}
    </div>
  )
}
